import React, { useEffect, useState } from 'react'
import { loadStripe } from '@stripe/stripe-js'
import { getStripePublicKey } from '../../../utils/payments'
import { Elements  } from '@stripe/react-stripe-js'
import { CheckoutForm } from './CheckoutForm'

function PaymentElement({ region, isLive, clientSecret }) {
  const [stripe, setStripe] = useState(null)

  useEffect(() => {
    if (!stripe && region && clientSecret) {
      setStripe(loadStripe(getStripePublicKey(region, isLive)))
    }
  }, [region, isLive])

  if (!stripe) {
    return null
  } else {
    const options = {
      clientSecret: clientSecret,
      layout: {
        type: 'accordion'
      }
    }

    return (
      <Elements stripe={stripe} options={options}>
        <CheckoutForm isLive={isLive}/>
      </Elements>
    )
  }
}

export default PaymentElement
